<template>
    <div class="property-examine3" style="margin-top: 10px;margin-left: 30px;">
        <el-card shadow="hover" style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);">
            <el-row :gutter="20">
                <el-col :span="7">
                    <el-button type="primary">
                        数据资产终审
                    </el-button>
                </el-col>

            </el-row>



            <el-row :gutter="20" type="flex" justify="end">
                <el-col :span="12" v-if="currentName === ''">
                    <el-input v-model="keywords" placeholder="请输入资产名称..." style="width: 300px; float: right"
                        @keydown.enter.native="doSearch">
                        <el-button slot="append" icon="el-icon-search" @click="doSearch"></el-button>
                    </el-input>
                </el-col>
            </el-row>
            <component v-bind:is="currentName" @changeName="changeName"></component>
            <div class="table" v-if="currentName === ''" style="margin-top: 20px; width: 100%">
                <el-table :data="tableData" border style="width: 100%" :header-cell-style="{ background: '#f5f5f5' }">

                     <el-table-column type="index" label="序号" width="80" align="center">
                    </el-table-column>

                    <el-table-column prop="registrationId" label="资产登记编号"  min-width="200"  align="center">
                    </el-table-column>

                    <el-table-column prop="creator" label="企业名称" min-width="230"   align="center">
                    </el-table-column>

                    <el-table-column prop="assetName" label="资产名称"  min-width="260"   align="center">
                    </el-table-column>

                           <el-table-column prop="dataSource" label="数据来源"  min-width="100"   align="center">
                    </el-table-column>

                           <el-table-column prop="industry" label="所属行业"  min-width="160"   align="center">
                    </el-table-column>

                    <el-table-column prop="registrationType" label="登记类型"  min-width="100"   align="center">
                    </el-table-column>

                    <el-table-column prop="state" label="状态"  min-width="100"   align="center">
                        <template slot-scope="scope">
                            <span :style="getStatusStyle(scope.row.state)">{{ scope.row.state }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="createTime" label="申请时间"   min-width="180"  align="center">
                    </el-table-column>

    

                    <el-table-column label="操作"  min-width="130"   align="center">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.state === '录入中' || scope.row.state === '审核驳回'" size="mini"
                                @click="handleEdit(scope.row)">编辑</el-button>
                            <el-button v-if="scope.row.state === '录入中'" size="mini" type="danger"
                                @click="handleDelete(scope.row)">删除</el-button>
                            <el-button v-else size="mini" type="primary" @click="handleView(scope.row)">审核</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-card>
        <div v-if="currentName === ''" class="block" style="position: absolute; left: 38%;margin-top: 20px">
            <el-pagination layout="prev, pager, next" :total="boardsTotal" :page-size="10" :current-page="currPage"
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import AddBoardContent from "../../components/AddBoardContent";

export default {
    name: "PublishBoard",
    data() {
        return {
            boardsTotal: 1,
            currPage: 1,
            keywords: '',
            currentName: '',
            tableData: [],
            columnWidth: 180,
        }
    },
    components: {
        AddBoardContent
    },
    watch: {},
    mounted() {
        this.initTableData('');
    },
    methods: {
        handleCurrentChange(val) {
            this.currPage = val;
            this.initTableData(this.keywords);
        },
        initTableData(keyword) {

            let user = JSON.parse(window.localStorage.getItem('user'));
            //console.log("useId:  " + user.id)


            this.getRequest('/web/dataAssets/queryAllInReviewList?state=待终审&keyword=' + keyword + '&currPage=' + this.currPage + '&pageSize=' + 10).then(resp => {
                //console.log(resp.data);
                if (resp) {
                    this.boardsTotal = resp.data.total;
                    this.tableData = resp.data.list;
                }
            });
        },
        doSearch() {
            //处理搜索逻辑
            this.initTableData(this.keywords);
        },
        changeName(name) {
            //console.log(this.currentName)
            this.currentName = name;
            if (name === '') {
                this.initTableData('');
                this.$store.commit('REMOVE_CURRENT_BOARD_ID');
            }
        },
        handleDelete(obj) {
            this.$confirm('是否永久删除名为：【' + obj.assetName + '】的数据资产？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.getRequest("/web/dataAssets/delete?registrationId=" + obj.registrationId).then(resp => {
                    if (resp && resp.status === 200) {
                        this.$message.success('删除成功');
                        this.initTableData('');
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        publishedSwitch(obj) {
            this.getRequest('/web/changeBoard/published?id=' + obj.id + '&published=' + obj.published).then(resp => {
            });
        },
        goToRegistration() {
            this.$router.push('/index/data-registration');
        },
        getStatusStyle(state) {
            switch (state) {
                case '录入中': return { color: '#67C23A' };
                case '待审核': return { color: '#409EFF' };
                case '待初审': return { color: '#409EFF' };
                case '待复审': return { color: '#409EFF' };
                case '待终审': return { color: '#409EFF' };
                case '审核驳回': return { color: '#F56C6C' };
                case '审核通过': return { color: '#409EFF' };
                default: return {};
            }
        },
        handleView(row) {
            // 跳转到审核页面
            this.$router.push({
                path: '/index/data-review',
                query: { registrationId: row.registrationId }
            });
        },
        handleEdit(row) {
            this.$router.push({
                path: '/index/data-registration',
                query: { registrationId: row.registrationId, mode: 'edit' }
            });
        }
    }
}
</script>


<style>
/* 表头样式 */
.property-examine3 .el-table__header th {
    text-align: center;
    font-size: 14px;
    color: rgb(46, 44, 44);
    background-color: #f5f5f5 !important;
}


</style>